/**
 * @dev
 * @param {(time: number) => void} onTick
 * @param {number} margin_ms 타이머 시작이 초에 근접한 시간이고 끝나는 시간이 근접한 것은 아니기 때문에, 실행시간 고려해서 미리 실행할 마진 시간
 * @return {() => number}
 */
// 정각 초의 이전이라는 정확히 보장 못함, 앞뒤로 근사치
export const setExactSecondInterval = function setExactSecondInterval(onTick, margin_ms) {
  let timer;

  const recur = function recur() {
    const now = Date.now();
    const rounded_now = Math.round(now / 1000) * 1000;
    const next_second = rounded_now + 1000;
    onTick(rounded_now); // 기준 시간 (초 단위)
    timer = setTimeout(recur, next_second - Date.now() - margin_ms);
  };

  timer = setTimeout(recur, 1000 - (Date.now() % 1000) - margin_ms);

  return () => timer;
};

export const clearExactSecondInterval = function clearExactSecondInterval(getTimerId) {
  clearTimeout(getTimerId());
};
